import axios from 'axios';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { getHubApiUrl, getHubAuthHeaders } from '../utils/hubApi';

const HUB_API_URL = getHubApiUrl();

/**
 * Updates the business segment for the company across Hub API, Firestore and local session.
 *
 * @param {string|number} companyId - Production company ID or Firestore account ID.
 * @param {string} segment - The new business segment (e.g. "Roupas / Moda").
 * @param {object} credencials - The user credentials object from StoreContext.
 * @param {function} [setCredencials] - Optional state updater from StoreContext to update session.
 */
export async function updateCompanySegment(companyId, segment, credencials, setCredencials) {
  if (!companyId || !segment) return;

  const targetAccountId =
    credencials?.companyData?.id || credencials?.company || companyId;

  // 1. Update session in memory
  if (credencials?.companyData) {
    credencials.companyData.segment = segment;
  }
  if (typeof setCredencials === 'function') {
    setCredencials((prev) => ({
      ...prev,
      companyData: {
        ...(prev?.companyData || {}),
        segment,
      },
    }));
  }

  // 2. Hub API (updates Firestore and syncs to MySQL companies.segment)
  try {
    const headers = await getHubAuthHeaders(credencials);
    if (headers?.Authorization) {
      await axios.put(
        `${HUB_API_URL}/accounts/${targetAccountId}`,
        { segment },
        { headers }
      );
    }
  } catch (apiErr) {
    console.warn('[updateCompanySegment] Hub API update warning:', apiErr);
  }

  // 3. Direct Firestore update
  try {
    const docRef = doc(db, 'accounts', String(targetAccountId));
    await updateDoc(docRef, {
      segment,
      updated_at: new Date(),
    });
  } catch (fsErr) {
    // Non-fatal if direct Firestore fails
  }
}
